import { useGetPortfoliosQuery } from "@redux/portfolios/portfoliosApi";
import { TableView } from "@covertree/ui/table/TableView";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  ADD_PORTFOLIO_ROUTES,
  PORTFOLIO_ROUTES,
  PORTFOLIOS_ROUTES,
} from "@routing/Portfolios/index";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Button } from "@covertree/ui";
import { featureFlags } from "@utils";

export function PortfoliosTable() {
  const navigate = useNavigate();

  const { data, isFetching, isError } = useGetPortfoliosQuery();

  const openPortfolioDetails = useCallback((id: string) => {
    navigate({
      pathname: `${PORTFOLIOS_ROUTES.PORTFOLIO}/${encodeURIComponent(id)}`,
    });
  }, []);

  const openAddNewPortfolio = useCallback(() => {
    navigate({
      pathname: `${PORTFOLIOS_ROUTES.PORTFOLIO}/${PORTFOLIO_ROUTES.ADD}/${ADD_PORTFOLIO_ROUTES.CONFIGURATION}`,
    });
  }, []);

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h3">Portfolios</Typography>
        <Button
          onClick={openAddNewPortfolio}
          size="small"
          disabled={!featureFlags.addPortfolioViaIntegration.isEnabled()}>
          + Add portfolio
        </Button>
      </Stack>
      <TableView
        page={1}
        rowsPerPage={100}
        totalCount={(data ?? []).length}
        rows={(data ?? []).map((item) => ({
          id: item.id,
          data: [item.name, item.isActive ? "Active" : "Inactive", item.id],
          onClickRow: () => openPortfolioDetails(item.id),
        }))}
        columns={[
          { headerName: "Name" },
          { headerName: "Status" },
          { headerName: "ID" },
        ]}
        onPageChange={() => {}}
        error={isError}
        loading={isFetching}
      />
    </Box>
  );
}
